<form class="audit-edit-form" *ngIf="audit" [formGroup]="auditForm" novalidate>

  <mat-form-field class="audit-edit-form--title">
    <input matInput
           placeholder="Audit Title"
           formControlName="title"
           [readonly]="!isNew && canUpdate"/>
    <mat-error *ngIf="auditForm.get('title').hasError('exists')">
      Audit with this title already exists
    </mat-error>
    <mat-error *ngIf="auditForm.get('title').hasError('required')">
      This field is required
    </mat-error>
  </mat-form-field>

  <mat-form-field class="audit-edit-form--code">
    <input matInput placeholder="Audit Code (optional)" formControlName="code"
    [readonly]="canUpdate && !isDraft"/>
  </mat-form-field>

  <mat-form-field class="audit-edit-form--type">
    <mat-select placeholder="Audit Type"
                formControlName="type"
                [compareWith]="auditTypeCompareFn"
                [disabled]="canUpdate && !isDraft">
      <mat-option *ngFor="let auditType of auditTypes$ | async" [value]="auditType">
        {{ auditType.auditType }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="auditForm.get('type').hasError('required')">
      This field is required
    </mat-error>
  </mat-form-field>

  <mat-form-field class="audit-edit-form--description">
          <textarea matInput
                    #description
                    rows="3"
                    placeholder="Audit Description"
                    formControlName="description"
                    [readonly]="canUpdate && !isDraft"></textarea>
    <mat-hint align="end">{{ description.value.length || 0 }} / 2000</mat-hint>
    <mat-error *ngIf="auditForm.get('description').hasError('required')">
      This field is required
    </mat-error>
  </mat-form-field>

  <mat-form-field class="audit-edit-form--due-date">
    <input matInput
           formControlName="dueDate"
           placeholder="Audit Due Date"
           [min]="today"
           [matDatepicker]="dueDateDatePicker"
           [disabled]="canUpdate && !isDraft"
           [readonly]="canUpdate && !isDraft"/>
    <mat-datepicker-toggle matSuffix [for]="dueDateDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #dueDateDatePicker></mat-datepicker>
    <mat-error *ngIf="auditForm.get('dueDate').hasError('required')">
      This field is required
    </mat-error>
    <mat-error *ngIf="auditForm.get('dueDate').hasError('matDatepickerMin')">
      Due date must be in the future
    </mat-error>
  </mat-form-field>

  <mat-form-field class="audit-edit-form--owner-group">
    <mat-select placeholder="Audit Owner Group"
                formControlName="ownerGroup"
                [compareWith]="auditOwnerGroupCompareFn"
                [disabled]="canUpdate && !isDraft">
      <mat-option *ngFor="let ownerGroup of auditOwnerGroups$ | async" [value]="ownerGroup">
        {{ ownerGroup.auditOwnerGroup }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="auditForm.get('ownerGroup').hasError('required')">
      This field is required
    </mat-error>
  </mat-form-field>  

  <mat-form-field class="audit-edit-form--sme">
    <mat-select placeholder="Subject Matter Experts (SMEs)"
                formControlName="smeApprovers"                 
                [(ngModel)]="smeSelected"
                (ngModelChange)="onSmeSelection()">
      <mat-option *ngFor="let smeApprover of smeApprovers$ | async" [value]="smeApprover.id">
        {{ smeApprover.fullName }}
      </mat-option>   
      <mat-option class="no-checkbox" *ngIf="!auditForm.get('ownerGroup').valid" disabled>
        Please select the Audit Owner Group first
      </mat-option>   
    </mat-select>   
    <mat-error *ngIf="auditForm.get('smeApprovers').hasError('required')">
      This field is required
    </mat-error> 
  </mat-form-field>

  <mat-form-field class="audit-edit-form--submiter" *ngIf="canUpdate">
    <mat-select placeholder="Submiter"
                formControlName="submiters" 
                [(ngModel)]="submiterSelected"
                (ngModelChange)="onSubmiterSelection()">
      <mat-option *ngFor="let submiter of submiters$ | async" [value]="submiter.id">
        {{ submiter.fullName }}
      </mat-option>      
    </mat-select>    
  </mat-form-field>

  <mat-form-field class="audit-edit-form--external"
                  *ngIf="auditForm.get('type').value?.auditType === '3rd Party Audit'">
    <input matInput
           placeholder="External Partner"
           formControlName="externalPartner"/>
  </mat-form-field>
</form>
